export function planetsScroller() {
    let isDragging = false;
    let dragStartX = 0;
    let scrollOffset = 100 * this.scaleFactor; // Scale the offset
    let velocity = 0;

    this.input.on('pointerdown', function (pointer) {
        isDragging = true;
        dragStartX = pointer.x;
        velocity = 0;
    }, this);

    this.input.on('pointerup', (pointer) => {
        isDragging = false;

        // Get first and last planets
        let firstPlanet = this.planetsGroup.getFirst(true);
        let lastPlanet = this.planetsGroup.getLast(true);

        // Scale the xOffset correctly
        let scaledXOffset = this.xOffset / 2 * this.scaleFactor;
        let scaledSceneW = this.sceneW - scaledXOffset - scrollOffset;

        // Snap back to the edges with an elastic effect
        if (firstPlanet.x >= scaledXOffset + scrollOffset) {
            this.startEdgeTween = this.tweens.add({
                targets: this.planetsGroup.getChildren(),
                x: `+= ${scaledXOffset - firstPlanet.x}`,
                duration: 500,
                ease: 'Back.Out'
            });
        }
        if (lastPlanet.x <= scaledSceneW) {
            this.lastEdgeTween = this.tweens.add({
                targets: this.planetsGroup.getChildren(),
                x: `-= ${(lastPlanet.x - scrollOffset) - lastPlanet.x}`,
                duration: 500,
                ease: 'Back.Out'
            });
        }
    });

    this.input.on('pointermove', function (pointer) {
        if (isDragging) {
            let deltaX = pointer.x - dragStartX;
            dragStartX = pointer.x;
            velocity = deltaX;

            this.planetsGroup.children.iterate(function (planet) {
                planet.x += deltaX;
            });

            // Get first and last planets
            let firstPlanet = this.planetsGroup.getFirst(true);
            let lastPlanet = this.planetsGroup.getLast(true);

            let scaledXOffset = this.xOffset * this.scaleFactor;
            let scaledSceneW = this.safeZoneX - scaledXOffset - scrollOffset;

            // Ensure planets stay within the scaled range
            if (firstPlanet.x > scaledXOffset + scrollOffset) {
                let offset = (scaledXOffset + scrollOffset) - firstPlanet.x;
                this.planetsGroup.children.iterate(function (planet) {
                    planet.x += offset;
                });
            }
            if (lastPlanet.x < scaledSceneW) {
                let offset = scaledSceneW - lastPlanet.x;
                this.planetsGroup.children.iterate(function (planet) {
                    planet.x += offset;
                });
            }
        }
    }, this);

    this.time.addEvent({
        delay: 16,
        loop: true,
        callback: function () {
            if (!isDragging && Math.abs(velocity) > 0.1) {
                this.planetsGroup.children.iterate(function (planet) {
                    planet.x += velocity;
                });

                // Apply friction to slow down the scrolling
                velocity *= 0.95;

                // Get first and last planets
                let firstPlanet = this.planetsGroup.getFirst(true);
                let lastPlanet = this.planetsGroup.getLast(true);

                let scaledXOffset = this.xOffset * this.scaleFactor;
                let scaledSceneW = this.sceneW - scaledXOffset - scrollOffset;

                // Ensure planets stay within the scaled range
                if (firstPlanet.x > scaledXOffset + scrollOffset) {
                    let offset = (scaledXOffset + scrollOffset) - firstPlanet.x;
                    this.planetsGroup.children.iterate(function (planet) {
                        planet.x += offset;
                    });
                    velocity = 0;
                }
                if (lastPlanet.x < scaledSceneW) {
                    let offset = scaledSceneW - lastPlanet.x;
                    this.planetsGroup.children.iterate(function (planet) {
                        planet.x += offset;
                    });
                    velocity = 0;
                }
            }
        },
        callbackScope: this
    });
}